module.exports = __webpack_public_path__ + "img/slide3_img1.c4caeadd.png";